/**
 * Contrato Stripe ↔ brand en cuenta plataforma multi-creator (DLY).
 * Fuente única: frontend, API admin, validadores, provision script (por convención).
 */

/** Cuenta Stripe plataforma (display name en Dashboard: DLY). */
export const STRIPE_PLATFORM_ACCOUNT_ID = "acct_1Kg7PfH8xCanmtKX" as const;

export const STRIPE_BRAND_METADATA_SOURCE_KEY = "source" as const;
export const STRIPE_BRAND_METADATA_BRAND_KEY = "brand" as const;

/** Valor canónico juaperrone.com — runtime usa BRAND_SOURCE_KEY env. */
export const STRIPE_BRAND_SOURCE_VALUE = "juaperrone" as const;

/** Nombre canónico en checkout Stripe + admin (VIP intl). */
export const STRIPE_EXCLUSIVE_MEMBERSHIP_PRODUCT_NAME = "Exclusive Membership" as const;

/** @deprecated Dashboard legacy — provision script busca ambos nombres. */
export const STRIPE_EXCLUSIVE_MEMBER_PRODUCT_NAME_LEGACY = "Exclusive Member" as const;

/** Alias histórico — usar STRIPE_EXCLUSIVE_MEMBERSHIP_PRODUCT_NAME. */
export const STRIPE_EXCLUSIVE_MEMBER_PRODUCT_NAME =
  STRIPE_EXCLUSIVE_MEMBERSHIP_PRODUCT_NAME;

export interface StripeDualCtaVariantContract {
  readonly variantId: string;
  readonly stripeProductId: string;
  readonly stripePriceId: string;
  readonly priceUsd: number;
  readonly planTier: "vip";
  readonly flow: "menu_subscription";
}

/** Promotion code Stripe (promo_*) aplicado al checkout default USExclusiveLanding. */
export const STRIPE_EXCLUSIVE_MEMBERSHIP_PROMOTION_CODE_ID =
  "promo_1TquJsH8xCanmtKXkSdwPqS1" as const;

export const STRIPE_DUAL_CTA_VARIANT_CONTRACT: readonly StripeDualCtaVariantContract[] = [
  {
    variantId: "vip_exclusive_default",
    stripeProductId: "prod_UqbVqDInMZ1S48",
    stripePriceId: "price_1TquIYH8xCanmtKXSrVP1CwE",
    /** Live Stripe unit_amount=3999 — Exclusive Membership ($39.99/mo). Promo EXCLUSIVE75. */
    priceUsd: 39.99,
    planTier: "vip",
    flow: "menu_subscription",
  },
  {
    variantId: "us_test2",
    stripeProductId: "prod_Ui3NKTQiu1UulY",
    stripePriceId: "price_1TidGtH8xCanmtKX9vPOmBCI",
    priceUsd: 18.94,
    planTier: "vip",
    flow: "menu_subscription",
  },
] as const;

export const STRIPE_LEGACY_VIP_PRODUCT_ID = "prod_UhRRz6j3577RQa" as const;

export const STRIPE_BRAND_CHECKOUT_METADATA_KEYS = [
  "source",
  "brand",
  "plan_tier",
  "flow",
] as const;